export const tableColumns = [
  {
    label: "姓名",
    value: "name"
  },
  {
    label: "手机号",
    value: "telephone"
  },
  {
    label: "部门",
    value: "department"
  },
  {
    label: "职位",
    value: "companyScope.position"
  },
  {
    label: "角色",
    value: "role"
  }
]
